import { ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';
import { ACTION_POSITIONS, MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import useConfirmPopup, {
  useConfirmPopupReturn,
} from '@/src/components/common/Elements/Modal/useConfirmPopup';

export type UseConfirmDisconnectProps = {
  message: string;
};
export const useConfirmDisconnect = ({ message }): useConfirmPopupReturn => {
  const [DisconnectModal, confirmDisconnect, cancelDiscard] = useConfirmPopup({
    icon: { icon: 'error_outline', iconType: ICON_TYPES.outlined },
    title: 'Disconnect Account?',
    confirmBtn: {
      label: 'Yes, proceed.',
    },
    message: message,
    modalType: MODAL_TYPE.danger,
    actionPosition: ACTION_POSITIONS.between,
  });

  return [DisconnectModal, confirmDisconnect, cancelDiscard];
};
